import axios from "axios";

export default axios.create({
     baseURL: `https://peekzy.in/backend/public/`,
    //  baseURL: `http://localhost:8082/`,
    // imagepath: `http://localhost:8080/public/assets/uploads/`,
    // imagepath: `https://peekzy.in/backend/public/assets/uploads/`
})